export const startOrResetInterval = ({ref, callbackFn, interval}) => {
	if (ref.current) clearInterval(ref.current)

	ref.current = setInterval(() => {
		callbackFn()
	}, interval)
}
